import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../services/common.service';
import { ConfigService } from '../services/config.service';
import { UserService } from '../services/user.service';
import { LayoutComponent } from '../theme/layout/layout.component';
import { EditorTextComponent } from './editor-text/editor-text.component';
import { BrandsComponent } from './brands/brands.component';
import { ConfigServiceService } from '../services/config-service.service';

@Component({
  selector: 'app-home',
  imports: [LayoutComponent,EditorTextComponent ,BrandsComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {
  destinationLat:any;
  destinationLng:any;
  distance:any;
  distanceSelection: any;
  commonData: any;
  pinCodeList: any;
  deliveryRange:any;
  pinCodeSelection:any;
  country:any;
  websiteBackgoundColor: any;
  homePageLayoutLoadedMob: any =3;
  homePageLayoutLoadedWeb: any =3;
  @Input() data: any;
  loaded: boolean=false;
  warehouseBasedAllocation: any;


  constructor(private commonService: CommonService,
      private configService :ConfigServiceService,
      public router: Router,
      private auth: UserService    
  ) {

    if(!localStorage.getItem('latitude') || localStorage.getItem('latitude')==null || localStorage.getItem('latitude')==undefined ||
        !localStorage.getItem('longitude') || localStorage.getItem('longitude')==null || localStorage.getItem('longitude')==undefined
    ){
      this.getConfigData();
    }
  }



 
  ngOnInit() {

    let basicAuthHeaderString = this.auth.getAuthenticatedToken();
    
    let loginPage: any = localStorage.getItem('redirectToLoginPage');

    if (!basicAuthHeaderString) {
      if (loginPage == 1) {
        this.router.navigate(['/login']);
      }
    }
  
    this.loaded=true;
    console.log("home");
    
  }

  getConfigData() {
    this.configService.getConfigData()
      .subscribe(
        (data:any) => {
          localStorage.setItem('GetConfigData', JSON.stringify(data));
          // this.commonService.setCurrencyValue(data['currencyBase'])
          this.pinCodeSelection = data['avaliablePincodes'];
          this.country=data['country'];
          this.destinationLat=data['supplierLatitude'];
          this.destinationLng=data['supplierLongitude'];
          
          this.distanceSelection=data['googleMapsEnabled'];
          this.deliveryRange=data['deliveryRange'];
          this.websiteBackgoundColor=data['websiteBackgoundColor'];
          this.commonData=data;  

          this.warehouseBasedAllocation = data['warehouseBasedAllocation'] == undefined ?
          1 : data['warehouseBasedAllocation'];

        if (this.warehouseBasedAllocation == 1) {

          let dstLat = localStorage.getItem("dstLat");
          let dstLong = localStorage.getItem("dstLon");

          if(dstLat!=null && dstLong!=null ){
            this.destinationLat = dstLat;
            this.destinationLng = dstLong;
          }


        }
          }, () => {
            this.pinCodeSelection =0;

          }
          );
}



   
}
